export enum AddressResolveQualityGroupType {
  Low = "Low",
  Medium = "Medium",
  High = "High",
}
